import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

/**
 * PermissionGate - Conditionally renders children based on user permissions.
 *
 * Usage:
 *   <PermissionGate permission="project.foundation.analysis.edit" projectId={id}>
 *     <EditButton />
 *   </PermissionGate>
 *
 *   <PermissionGate permission="user.create" fallback={<span>No access</span>}>
 *     <CreateUserButton />
 *   </PermissionGate>
 */
const PermissionGate = ({ permission, projectId, fallback = null, exact = false, children }) => {
  const { hasPermission, loading, user } = useContext(AuthContext);
  const params = useParams();
  const effectiveProjectId = projectId || params.projectId;

  // Don't render anything while auth is loading to prevent flash
  if (loading || !user) return null;

  if (hasPermission(permission, effectiveProjectId, { exact })) {
    return children;
  }
  return fallback;
};

export default PermissionGate;
